﻿import { AnnualFeeStatus } from '../enums/index';
import { IContact } from './contact';

export interface IBillingPreparationReport {
    centerId: number;
    invoiceDate: string;
    isSuspended: boolean;
    isAdpPartner: boolean;
    isBillableKidney: boolean;
    isBillableLiver: boolean;
    isLiverPlDash: boolean;
    isBillableKidneyOverride: boolean;
    isBillableLiverOverride: boolean;
    isAllIn: boolean;
    isDcn: boolean;
    centerAlias: string;
    liaison: IContact;
    executiveSponsor: IContact;
    preselectAverage: number;
    dataComplianceFailed: number;
    cryoLate: number;
    rexmLate: number;
    preselectReversals: number;
    surgicalDeclines: number;
    surgicalDeclinesBillable: number;
    lateVxm: number;
    netChainsStarted: number;
    billableRccaps: number;
    lateSerologies: number;
    bloodDrawsOutsideWindow: number;
    hasUpdatedContract: boolean;
    isOutdatedContractBillable: boolean;
    expectedMonthlyDbFee: number;
    expectedMonthlyNkrFee: number;
    rmcrFeeTotal: number;
    lastMonthlyFee: number;
    lastNkrFee: number;
    allInAgreement: boolean;
    hadTxpsInPriorYear: boolean;
    hadTxpsInLast12: boolean;
    monthlyFee: number;
    monthlyFeeNotes: string;
    transplantsLast12Months: number;
    voucherHoldersLast12Months: number;
    voucherHoldersCumulative: number;
    vxmAnalysis: number;
    vxmAnalysisCategory: string;
    onTimeKidneyPickup: number;
    onTimeKidneyPickupCount: number;
    onTimeKidneyPickupOfTotal: number;
    annualFeeStatus: AnnualFeeStatus;
    ncsGap: number;
    dashBillingExpectedFee: number;
    dashBillingActualFee: number;
    dashBillingPriorYearLds: number;
    dashBillingNotes: string;
    followUpFullyUtilized: boolean;
    isUDash: boolean;
    referredDonorsUnprotected: number;
    coldIschemiaLagTimes: number;
    lateFinalXm: number;
    dsDiscountCprScore: number;
    dsDiscountPercent: number;
    dsPercentProtectedKidney: number;
    dsPercentProtectedLiver: number;
    dsDiscountProtectedDonors: boolean;
    dsDiscountProtectedEndDate: Date | null;
    dsDiscountVouchersLast12: number;
    dsDiscountProtectedLiver: boolean;
    dsDiscountOverrideProtectedKidney: boolean;
    dsDiscountOverrideProtectedLiver: boolean;
    kidneyDonorsProtected: number;
    kidneyDonorsTotal: number;
    liverDonorsProtected: number;
    liverDonorsTotal: number;
}